import type {
  CommunityEnum,
  FirstLanguageEnum,
  NationalitiesEnum
} from '@/api/v1/generated-api.gen'
import { httpService } from '@/api/v1/http.service'
import useMutationWithErrorsHandling from '@/hooks/useMutationWithErrorsHandling'
import { formatApiDate } from '@/utils/format-date'
import { getValue } from '@/utils/get-value'

import {
  studentErrorsMapper,
  type StudentForm
} from '../constants/student-payload'

const useAddStudent = (options?: {
  onSuccess?: ({
    response,
    variables
  }: {
    response: { id: string }
    variables: StudentForm
  }) => void
  onError?: (validData: StudentForm) => void
}) =>
  useMutationWithErrorsHandling({
    mutationFn: (data: StudentForm) =>
      httpService.panel.panelStudentsCreate({
        email: data.email,
        phone_number: data.phoneNumber,
        first_name: data.firstName,
        last_name: data.lastName,
        ahv_number: data.ahvNumber,
        date_of_birth: formatApiDate(data.birthDate),
        gender: data.gender,
        nationalities: data.nationalities.map(getValue) as NationalitiesEnum[],
        first_language: data.firstLanguage?.value as
          | FirstLanguageEnum
          | undefined,
        community: data.community?.value as CommunityEnum | undefined,
        send_activation_link: data.sendActivationLink,
        student_class: data.class?.value,
        academic_level: data.academicLevel,
        parents: data.guardians.map(guardian => ({
          email: guardian.email,
          first_name: guardian.firstName,
          last_name: guardian.lastName,
          send_activation_link: guardian.sendActivationLink,
          id: guardian.id || undefined,
          phone_number: guardian.phoneNumber || undefined
        }))
      }),
    onSuccess: (response, variables) =>
      options?.onSuccess?.({ response, variables }),
    onError: (_, variables) => options?.onError?.(variables),
    fieldErrorsMapper: studentErrorsMapper
  })

export default useAddStudent
